class QuickOrderFeed {
  // Define tiers for each category
  static tiers = {
    "Fragrance Oils": [2, 6, 12, 24],
    Wax: [6, 12, 24, null],
    "Wicks & Reeds": [5, 10, 15, 20],
    "Pre-Packed Goods": [10, 20, 30, 40],
    "Loose Goods": [60, 120, 240, 480],
  };

  getTier(quantity, category) {
    const t = QuickOrderFeed.tiers[category] || [];
    if (!t.length) return null;
    if (t[3] && quantity >= t[3]) return 4;
    if (t[2] && quantity >= t[2]) return 3;
    if (t[1] && quantity >= t[1]) return 2;
    if (t[0] && quantity >= t[0]) return 1;
    if (t[0] && quantity >= 1 && quantity < t[0]) return 0;
    return null;
  }

  updateUnlockedLabel(item) {
    // Get product category from a data attribute on the picker or item
    const picker = item.querySelector(".label-bulk-order");
    let productCategory = picker?.getAttribute("data-product-category");
    const quantityInput = item.querySelector('input[name="quantity"]');
    if (!quantityInput || !productCategory) return;
    const quantity = parseInt(quantityInput.value, 10);
    if (isNaN(quantity)) return;
    const tier = this.getTier(quantity, productCategory);
    item.querySelectorAll(".label--wrapper").forEach((el) => {
      el.classList.remove("label-unlocked-price");
    });
    if (tier !== null) {
      const tierLabel = item.querySelector(".label--wrapper-tier-" + tier);
      if (tierLabel) tierLabel.classList.add("label-unlocked-price");
    }
  }
  constructor(element) {
    this.element = element;
    // All the items in the feed
    this.items = this.element.querySelectorAll(".quick-order-item");
    this.addAll = this.element.querySelector(".quick-order-add-all");
    if (this.addAll) {
      this.addAll.addEventListener("click", () => this.addAllToCart());
    }

    this.items.forEach((item) => {
      // Product form updates
      const form = item.querySelector("form");
      if (form) {
        // Listen to variant changes in the form
        const variantSelects = form.querySelectorAll(
          "variant-selects, variant-radios"
        );
        variantSelects.forEach((variantSelect) => {
          variantSelect.addEventListener("change", (event) => {
            this.updateVariant(event, item);
            this.setAddAllButtonState();
            this.updateUnlockedLabel(item);
          });
        });
        // Listen for quantity changes
        const quantityInput = form.querySelector('input[name="quantity"]');
        if (quantityInput) {
          quantityInput.addEventListener("input", () => {
            this.setAddAllButtonState();
            this.updateUnlockedLabel(item);
          });
          quantityInput.addEventListener("change", () => {
            this.updateUnlockedLabel(item);
          });
        }
      }
      //   Item content updates
      item.priceInfo = item.querySelector(".quick-order-item--pricing");
      this.updatePricing(item);
      // Initial highlight
      this.updateUnlockedLabel(item);
    });

    // Move variant select on load and resize
    this.moveVariantSelect = this.moveVariantSelect.bind(this);
    window.addEventListener("resize", this.moveVariantSelect);
    this.moveVariantSelect();

    // Initial state
    this.setAddAllButtonState();
  }

  moveVariantSelect() {
    // This function shifts the variant selector based on screen size, so it can sit under the title
    const lgBreakpoint = 1232;
    this.items.forEach((item) => {
      const info = item.querySelector(".quick-order-item--info");
      const form = item.querySelector(".quick-order-item--form form");
      const variantSelect = item.querySelector(".quick-order-variant-select");
      if (!info || !form || !variantSelect) return;

      // If below lg, move after title in info
      if (window.innerWidth < lgBreakpoint) {
        const title = info.querySelector(".quick-order-item--title");
        if (title && variantSelect.parentNode !== info) {
          info.insertBefore(variantSelect, title.nextSibling);
        }
      } else {
        // If lg or above, move back to top of form
        if (variantSelect.parentNode !== form) {
          form.insertBefore(variantSelect, form.firstChild);
        }
      }
    });
  }

  setAddAllButtonState() {
    // Disable only if all products have quantity 0 or are out of stock
    let allProductsDisabled = true;
    this.items.forEach((item) => {
      const form = item.querySelector("form");
      if (!form) return;
      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      const addButton = form.querySelector('button[name="add"]');
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 0;
      // If any product has quantity > 0 and is in stock (addButton enabled), set flag to false
      // if (variantInput && quantity > 0 && addButton && !addButton.disabled) {
      if (variantInput && quantity > 0) {
        allProductsDisabled = false;
      }
    });
    if (this.addAll) {
      this.addAll.disabled = allProductsDisabled;
    }
  }

  updateVariant(event, item) {
    this.updatePricing(item);
  }

  //Update the displayed pricing info to the current selected variant
  updatePricing(item) {
    // Get the selected variant id
    const form = item.querySelector("form");
    const variantInput = form.querySelector('input[name="id"]');
    const selectedVariantId = variantInput ? variantInput.value : null;
    // Get the matching variant's info
    const priceInfo = item.priceInfo;
    if (!priceInfo) return;
    // Hide all the others
    priceInfo.querySelectorAll('[class^="variant-pricing-"]').forEach((el) => {
      el.style.display = "none";
    });
    // Show the matching info
    const match = priceInfo.querySelector(
      `.variant-pricing-${selectedVariantId}`
    );
    if (match) match.style.display = "";
  }

  // Collect all product/variant IDs and their quantities from the quick order list
  getProductsToAdd() {
    const products = [];
    this.items.forEach((item) => {
      const form = item.querySelector("form");
      if (!form) return;
      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      const addButton = form.querySelector('button[name="add"]');
      const variantId = variantInput ? variantInput.value : null;
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) : 0;
      // Only add if in stock and quantity > 0
      if (variantId && quantity > 0 && addButton && !addButton.disabled) {
        products.push({ id: variantId, quantity });
      }
    });
    return products;
  }

  // Add all products to cart
  addAllToCart() {
    const products = this.getProductsToAdd();
    if (!products.length) return;

    // Add loading class to button (As adding them all can take a hot second)
    if (this.addAll) this.addAll.classList.add("loading");

    // Loop through items to add them to cart
    // We have to go 1 by 1 since Shopify doesn't seem to allow a mass add here
    const items = products.map((p) => ({ id: p.id, quantity: p.quantity }));
    const addNext = (index = 0) => {
      if (index >= items.length) {
        // All items added, trigger a cart drawer update
        fetch("/cart?sections=cart-drawer,cart-icon-bubble")
          .then((res) => {
            return res.json();
          })
          .then((parsedState) => {
            let stateForDrawer;
            if (parsedState.sections) {
              stateForDrawer = parsedState;
            } else {
              stateForDrawer = { sections: parsedState };
            }
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer && typeof cartDrawer.renderContents === "function") {
              try {
                cartDrawer.renderContents(stateForDrawer);
              } catch (err) {
                console.error("Error calling cartDrawer.renderContents:", err);
              }
            } else {
              console.warn("cartDrawer or renderContents not found");
            }
          })
          .catch((err) => {
            console.error("Error fetching or updating cart drawer:", err);
          })
          .finally(() => {
            if (this.addAll) this.addAll.classList.remove("loading");
            // remove .is-empty from cart-drawer
            const cartDrawerElement = document.querySelector("cart-drawer");
            if (cartDrawerElement) {
              if (cartDrawerElement.classList.contains("is-empty")) {
                cartDrawerElement.classList.remove("is-empty");
              }
            }
            console.log("Cart updated");
          });
        return;
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: items[index].id,
          quantity: items[index].quantity,
        }),
      })
        .then((res) => res.json())
        .then(() => addNext(index + 1))
        .catch((err) => {
          console.error("Error adding to cart:", err);
          addNext(index + 1);
        });
    };
    addNext();
  }
}

// Instantiate for each .quick-order-feed on the page
document.querySelectorAll(".quick-order-feed").forEach((el) => {
  new QuickOrderFeed(el);
});
